import React from "react";
import LegalLayout from "./LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="プライバシーポリシー">
      <p className="dw-legal__date">最終更新日：2026年3月14日</p>
      <p>合同会社GK3（以下「当社」）は、ナイトワーク求人マッチングサービス「DressWork」（以下「本サービス」）において、ユーザーの個人情報を以下の方針に基づき適切に取り扱います。</p>
      <h2>1. 収集する情報</h2>
      <p><strong>（1）ユーザーが提供する情報</strong></p>
      <p>氏名、電話番号、LINE ID、年齢、身長、体重、顔写真、勤務希望条件</p>
      <p><strong>（2）自動的に収集される情報</strong></p>
      <p>端末情報、IPアドレス、アクセスログ、Cookie情報、利用履歴</p>
      <h2>2. 情報の利用目的</h2>
      <p>（1）求人情報のマッチング及びご紹介</p>
      <p>（2）求人店舗への応募者情報の提供（ユーザーの同意がある場合）</p>
      <p>（3）ユーザーへの連絡・ご案内</p>
      <p>（4）本サービスの運営・改善・新機能の開発</p>
      <p>（5）利用規約に違反する行為への対応</p>
      <p>（6）お問い合わせへの対応</p>
      <h2>3. 第三者への提供</h2>
      <p>当社は、ユーザーの同意がある場合、法令に基づく場合、人の生命・身体・財産の保護に必要な場合、業務委託先への提供を除き、個人情報を第三者に提供しません。</p>
      <h2>4. 写真データの取り扱い</h2>
      <p>顔写真は求人店舗への紹介目的でのみ使用し、退会時に速やかに削除します。</p>
      <h2>5. 情報の管理</h2>
      <p>個人情報はFirebase（Google LLC）のクラウドサービスを利用して安全に保管されます。</p>
      <h2>6. ユーザーの権利</h2>
      <p>ユーザーは個人情報の開示・訂正・削除・利用停止を請求できます。アプリ内の退会機能でアカウント及びデータを削除できます。</p>
      <h2>7. Cookie及び分析ツール</h2>
      <p>Google Analyticsを使用することがあります。データは匿名で収集されます。</p>
      <h2>8. 未成年者の利用</h2>
      <p>本サービスは18歳以上の方を対象としています。</p>
      <h2>9. プライバシーポリシーの変更</h2>
      <p>必要に応じて本ポリシーを変更することがあります。</p>
      <h2>10. お問い合わせ</h2>
      <p>合同会社GK3</p>
      <p>メール：gk3gogogo@gmail.com</p>
      <p className="dw-legal__company">合同会社GK3</p>
    </LegalLayout>
  );
}
